import VueRouter from "vue-router";
import routes from "./routes";

const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        };
    }
});

router.beforeEach((to, from, next) => {
    // localStorage.setItem('access_token', '')
    let user_id = localStorage.getItem('user_id')
    let token = localStorage.getItem('access_token')

    if (to.path == '/iso/accept_offer' || to.path == '/iso/reject_offer' || to.path == '/iso_email_reply' 
    || to.path == '/subform') {
        localStorage.clear()
        next();
    }
    else if (to.path != '/login' && !(token && (user_id && user_id != '0'))){
        next({path: '/login'});
    }
    else if (to.path == '/'){
        if(token)
            next({path: '/dashboard'});
        else
            next({path: '/login'});
    }else if (to.path == '/login' && token){
        next({path: '/dashboard'});
    }
    next();
});

export default router

